import React from 'react'
import { Col, Row } from "react-bootstrap";
const Footer = () => {
    return (
        <footer className="app-footer p-2 text-white">
            <Row className="g-0 w-100">
                <Col xs={12} className="text-center">
                    ©Copyright<a className="text-white" href="https://jajot.in/" target='__blank'>
                        <b className='mx-2'>Jajot Enterprises Pvt. Ltd.</b> All Rights Reserved.
                    </a>
                </Col>
            </Row>
        </footer>
    )
}

export default Footer